import React, { useContext, useEffect, useState } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";
import GlobalContext from "../../../contexts/globalContext";
import { saveForm, getToken } from "../../../services/formServices";
import { saveSocialUserData } from "../../../services/social.services";
import Modal from "../../ui/modal/Modal";

//Styles
import "./FormRegistroLideres.scss";
import rawToReact from "../../../utils/rawToReact";

interface FormRegistroLideresProps {
    displayForm: boolean;
    setDisplayForm: (state: boolean) => void;
}

const FormRegistroLideres = (props: FormRegistroLideresProps) => {
    // Obtiene el contenido de un formulario de tipo Contactenos desde contentful
    const data = useStaticQuery(graphql`
        query contentfulFormRegistroLideres {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "3RR7mUzvJec3nFDuHekerE" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                        }
                        tituloBoton
                    }
                }
            }
            modalUnsuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "5Ls3R5fVLAnPGB7MZdnwHA" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
    const contentfulData = data.form.nodes[0];
    const modalUnsuccess = data.modalUnsuccess.nodes[0];
    const Context = useContext(GlobalContext);

    const defaultFormValues = {};

    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [displayModal, setDisplayModal] = useState<boolean>(false);
    const [formValues, setFormValues] = useState(defaultFormValues);

    const topicsOptions = [
        "topic_1",
        "topic_2",
        "topic_3",
        "topic_4",
        "topic_5",
    ];

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    const updateInputValue = (field: string, value: any, type?: string) => {
        if (topicsOptions.includes(field)) {
            if (value) {
                if (typeof value === "boolean") {
                    setFormValues((prev: any) => {
                        return { ...prev, [field]: "SÍ" };
                    });
                } else {
                    setFormValues((prev: any) => {
                        return { ...prev, [field]: value };
                    });
                }
                setFormValues((prev: any) => {
                    return { ...prev, topics: "SÍ" };
                });
            } else {
                const auxFormValues = { ...formValues };
                delete auxFormValues[field];
                setFormValues(auxFormValues);
                let count = 0;
                topicsOptions.forEach((field) => {
                    if (auxFormValues[field]) {
                        count++;
                    }
                });
                if (count === 0) {
                    delete auxFormValues.topics;
                    setFormValues(auxFormValues);
                }
            }
        } else if (type && type === "checkbox") {
            if (value) {
                setFormValues((prev) => {
                    return { ...prev, [field]: "SÍ" };
                });
            } else {
                const auxFormValues = { ...formValues };
                delete auxFormValues[field];
                setFormValues(auxFormValues);
            }
        } else {
            if (inputRegexValidation(field, value)) {
                setFormValues((prev) => {
                    return { ...prev, [field]: value };
                });
            }
        }
    };

    const createPayload = () => {
        const payload = {
            idForm: 5,
            answers: [],
        };

        Object.entries(formValues).forEach(([key, value]) => {

            if (key === 'profilePicture') value = Context.gigyaContext.gigyaAccount?.profile.photoURL;
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };

   const updateProfileGiygaPhoto = async () => {
        // Convert Image to base64 and save in gigya account
        if (!!formValues.profilePicture && formValues.profilePicture.type) {
            const reader = new FileReader();
            reader.onloadend = () => {
                Context.gigyaContext.updateProfilePhoto(reader.result?.replace(/data:image.*\;base64\,/, ''))
            };
            reader.readAsDataURL(formValues.profilePicture);
        }
    }

    const closeForm = (status) => {
        props.setDisplayForm(false);
        if (status === 200) {
            Context.showModalNewLeader?.set(true);
        } else {
            setDisplayModal(true);
        }
    };

    const handleSubmitForm = async () => {
        try {
            setDisabledButton(true);
            await updateProfileGiygaPhoto();
            setTimeout(async () => {
                const payload = createPayload();
                const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
                const response = await saveForm(payload, token);
                if (response.data.status === 200) {
                    const userData = {
                        "cedula": Context.gigyaContext.gigyaAccount!.data.docNumber,
                        "email": Context.gigyaContext.gigyaAccount!.profile.email,
                        "name": Context.gigyaContext.gigyaAccount!.profile.firstName + " " + Context.gigyaContext.gigyaAccount!.profile.lastName,
                        "photo": Context.gigyaContext.gigyaAccount?.profile.photoURL
                    };
                    saveSocialUserData(token, userData);
                }
                closeForm(response.data.status);
                setDisabledButton(false);
            }, 3000);
        } catch (error) {
            closeForm(400);
            console.log(error);
        }
    };

    // Precarga los datos desde gigya
    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount) {
            setFormValues({
                ...formValues,
                name:
                    Context.gigyaContext.gigyaAccount.profile.firstName +
                    " " +
                    Context.gigyaContext.gigyaAccount.profile.lastName,
                documentId: Context?.gigyaContext?.gigyaAccount?.data.docNumber,
                mobile: Context?.gigyaContext?.gigyaAccount?.data.mobile,
                email: Context?.gigyaContext?.gigyaAccount?.data.CDCEmail,
                profilePicture: Context.gigyaContext.gigyaAccount.profile.photoURL
            });
            setInputDisabled(["name", "documentId"]);
        } else {
            setInputDisabled([]);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    // Deshabilita el scroll cuando el form es visible
    useEffect(() => {
        document.body.style.overflow = displayModal ? "hidden" : "unset";
    }, [displayModal]);

    return (
        <>
            {props.displayForm && (
                <Modal showModal={props.displayForm} onClose={closeForm}>
                    <div className="o-form-registro-lideres">
                        <div
                            className={`o-form-registro-lideres__container ${Context.gigyaContext.gigyaAccount
                                ? "--disable-input"
                                : ""
                                }`}
                        >
                            {/* Renderiza el encabezado del formulario, como titulos y descripciones */}
                            <FormHead
                                tituloPrincipal={contentfulData.tituloPrincipal}
                                descripcion={contentfulData.descripcion}
                                tituloFormulario={
                                    contentfulData.tituloFormulario
                                }
                                descripcionFormulario={
                                    JSON.parse(contentfulData.descripcionFormulario.raw)
                                }
                            ></FormHead>

                            {/* Renderiza el cuerpo del formulario */}
                            <FormBody
                                // Campos y estilos del formulario
                                titulosFormulario={
                                    contentfulData.titulosFormulario
                                }
                                genericClassNameForm={contentfulData.metaTitulo}
                                setInputValue={updateInputValue}
                                formValues={formValues}
                                handleSubmitForm={handleSubmitForm}
                                inputDisabled={inputDisabled}
                                isDisabledButton={isDisabledButton}
                            ></FormBody>
                        </div>
                    </div>
                </Modal>
            )}
            {displayModal && (
                <Modal showModal={displayModal} onClose={() => setDisplayModal(false)}>
                    <div className='modal-unsuccess'>
                        <div className="modal-unsuccess-image">
                            <img src="https://images.ctfassets.net/gkhyeghj07ak/6m03XnZihvm3nFFlJzHZDF/0e4c890b4ca48b89a1ba9b36f2dfbfd3/check-error.png?h=100" alt="" />
                        </div>
                        <div className="modal-unsuccess-title">
                            <h1>{modalUnsuccess.tituloPrincipal}</h1>
                        </div>
                        <div className="modal-unsuccess-description">
                            <p>
                                {rawToReact(modalUnsuccess.descripcionFormulario.raw)}
                            </p>
                        </div>
                        <div className="modal-unsuccess-button">
                            <button type="button" onClick={() => setDisplayModal(false)}>{modalUnsuccess.tituloBoton}</button>
                        </div>
                    </div>
                </Modal>
            )
            }
        </>
    );
};

export default FormRegistroLideres;
